// extracted by mini-css-extract-plugin
module.exports = {"modal":"SmallScreenModal_modal__2tErS","close":"SmallScreenModal_close__26OEa","title":"SmallScreenModal_title__aezyM","text":"SmallScreenModal_text__cuaqI"};